export class MultiString {
    [language: string]: string;
}
